import React, { useState,useEffect } from "react";
import { HTTP } from "../../api/http-common";
import { Tabs, TabsList, TabsTrigger } from "@radix-ui/react-tabs";
import { cn } from "./../../lib/utils";
import CouponCard from "./../../component/CouponCard"
import Pagination from '../../component/pagination';
import { useGlobalContext } from "../../component/GlobalContext";

function MemberCoupon({backgroundColor=true}) {
  const { globalUserVar,isActiveMember } = useGlobalContext();
  const access_token = (localStorage.getItem('access_token'));
  const [categoriesList, setCategoriesList] = useState([]);
  const [activeCategory, setActiveCategory] = useState(1);
  const [filteredCoupons, setFilteredCoupons] = useState([]);
  const [total, setTotal] = useState(0);
  const [pagination, setPagination] = useState({ page: '1', limit: '10' });
  const [filterType, setFilterType] = useState("all");
  const [search, setSearch] = useState({ category_id: '' });
  const [currentPage, setCurrentPage] = useState(1);


  const fetchCoupons = async (couponData) => {
    let config = {
      headers: { 'Content-Type': 'application/json', 'token': access_token },
    }
    let fields = {
        filters: {
          category_id: activeCategory,
          coupon_type: filterType
        },
        pagination: pagination,
        sorting: { field: 'id', type: 'desc' },
    };
    HTTP.post('coupon/customer/list', fields, config)
        .then((response) => {
            const data = response.data;
            if (response.status === 200) {
              setFilteredCoupons(data.contents);
              setTotal(data.total_count);
            }
            if (response.status === 204) {
                // setAaMasters([])
            }
        })
        .catch((error) => {
            // setError(error)
            // setRerenderFlag(true);
        })
        .finally(() => {
            // setIsLoading(false);
        });
  };
  const onPaginationChange = (page) => {
      setPagination({ ...pagination, page });
  };
  const onLimitChange = (e) => {
      const newLimit = parseInt(e.target.value);
      setPagination({ ...pagination, limit: newLimit, page: 1 });
  };
  const loadCategories = async () => {
    try {
        let config = {
          headers: { 'Content-Type': 'application/json', 'token': access_token },
        }
        let fields = {
            filters: {
              // search_value: search.search_value,
            },
            pagination: { page: '1', limit: '100' },
            sorting: { field: 'name', type: 'asc' },
        };
        await HTTP.post("/business_cate/list/all",fields)
          .then(async (response) => {
            if (response.status === 200) {
                setCategoriesList(response.data.contents)
                // setActiveCategory(1)
            }
          })
          .catch((error) => {
            // setError(error);
            // setRerenderFlag(true);
            // loadAaMasterData();
            // resetValidationErrors();
          });

        // setIsLoading(false);
      } catch (error) {
        // setError(error);
        // setRerenderFlag(true);
        // setIsLoading(false);
      }
  }
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  useEffect(() => {
      loadCategories();
  }, []);
  useEffect(() => {
    fetchCoupons();
  }, [filterType,currentPage,pagination,activeCategory]);
  const handleTabClick = (categoryId) => {
    if (activeCategory !== categoryId) {
      setActiveCategory(categoryId);
    }
  };

  return (
    <>
    <div className='bg-[#F8F9FA] min-h-[calc(100vh-142px)]'>
      <div className="container mx-auto px-4 pt-8">
      <div className="mb-8 flex flex-col items-center">
          <h2 className="text-center text-2xl text-[#000]  mb-4 font-roboto italic tracking-[5%] leading-[28.13px]">
            FILTER COUPONS BY
          </h2>
          <Tabs
            value={activeCategory}
            onValueChange={(value) => setActiveCategory(value)}
            className="w-full"
          >
            <TabsList
              className="w-full justify-center gap-2 bg-transparent h-auto flex-wrap flex"
            >
              {categoriesList.map((category) => (
                <TabsTrigger
                  key={category.id}
                  value={category.id}
                  onClick={() => handleTabClick(category.id)}
                  className={cn(
                    activeCategory === category.id
                      ? "bg-[#6C1CFF] text-white"
                      : "bg-white text-black", // Styles for inactive tabs
                    "px-8 py-3 rounded-md border text-base max-w-max transition-colors duration-200"
                  )}
                >
                  {/* <span className="mr-2">{category.icon}</span> */}
                  {category.name}
                </TabsTrigger>
              ))}
            </TabsList>
          </Tabs>
        </div>
      </div>
      <div className={`container mx-auto rounded-xl py-6 pt-5 grid grid-cols-1 custom-lightest-border ${backgroundColor == true ? "bg-white": ''}`}>
      {/* <div className={`container mx-auto rounded-xl py-12 px-20 relative ${backgroundColor == true ? "bg-white": ''}`}> */}
        
        {Array.isArray(filteredCoupons) && filteredCoupons.length > 0 ? (
            <>
                <div className=" py-6 pt-8 grid grid-cols-1 xl:grid-cols-2 place-items-center gap-y-10 gap-x-0  max-h-[696px] overflow-y-auto scrollbar-hide custom-theme-scroll border  rounded-2xl mb-5 bg-[#fefefe] custom-lightest-border">
                {filteredCoupons.map((coupon, index) => (
                  <CouponCard key={coupon.id} coupon={coupon} />
                ))}
              </div>
              <Pagination total={total} pagination={pagination} handlePageChange={onPaginationChange} handleLimitChange={onLimitChange} />
            </>         
          ) : (
              <div>Coupon not found</div>
          )}
        
      </div>
    </div>
    
    </>
  )
}

export default MemberCoupon